/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".event-features__badge-container[_ngcontent-%COMP%]{padding:18px 30px}"];
export { styles as styles };
